export const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME;

export const ENDPOINTS = {
  getWellbeingTestResults: "/wellbeing",
  getWellbeingPlan: "/wellbeing/plan",
} as const;
